import { VisitorGroup } from 'graphql/generated/graphqlTypes';

export function generateMockVisitorGroup({
  accessGrants = [],
  allowedAccessGrants = [],
  defaultAccessGrants = [],
  scheduledAccessGrants = [],
  externalRef = 'mockVisitorGroupExternalRef',
  id = 'mockVisitorGroupId',
  isAdminGroup = false,
  isQrCodeVisitInviterGroup = false,
  maxNumberOfMembers = null,
  members = [],
  memberIds = [],
  name = 'mockVisitorGroupName',
  tenantId = 'mockVisitorGroupTenantId',
  type = 'mockVisitorGroupTenantType'
}: Partial<Omit<VisitorGroup, '__typename'>>): VisitorGroup {
  return {
    __typename: 'VisitorGroup',
    accessGrants,
    allowedAccessGrants,
    defaultAccessGrants,
    scheduledAccessGrants,
    externalRef,
    id,
    isAdminGroup,
    isQrCodeVisitInviterGroup,
    maxNumberOfMembers,
    members,
    memberIds,
    name,
    tenantId,
    type
  };
}
